export enum OrganizationTransaction {
    add = 0,
    update = 1,
    navigate = 2,
    testConnection = 3,
}

export enum ModalTransaction {
    ADD = 0,
    UPDATE = 1,
}
